export default "__VITE_ASSET__o$cLCglt__"